export { default } from 'cccisd-game-zoou-emp0';
